import { Component, type ErrorInfo, type ReactNode } from 'react';
import { EmptyState } from '@/shared/ui/EmptyState';

type Props = { children: ReactNode; resetKey?: string };
type State = { error: Error | null };

export class AppErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(_error: Error, _info: ErrorInfo): void {
    console.error('Showcase screen failed');
  }

  componentDidUpdate(previousProps: Props): void {
    if (this.state.error && previousProps.resetKey !== this.props.resetKey) {
      this.setState({ error: null });
    }
  }

  render(): ReactNode {
    if (this.state.error) {
      return (
        <EmptyState
          title="Не удалось открыть этот раздел"
          description="Вернитесь назад и попробуйте открыть раздел ещё раз"
        />
      );
    }
    return this.props.children;
  }
}
